import { useNavigate, useParams } from "react-router-dom";
import { Button, Skeleton } from "antd";
import CircleProgress from "../../../../shared/CircleProgress";

const UserAnalytics = (props: any) => {
  const { title, progress, points, analyticsLoading } = props;
  const { id } = useParams();
  const navigate = useNavigate();

  if (analyticsLoading) {
    return (
      <div
        className={`${
          title === "Overall Progress" ? "h-[230px]" : "h-[318px]"
        }`}
      >
        <Skeleton active paragraph={{ rows: 6 }} />
      </div>
    );
  }
  return (
    <>
      <div className="flex justify-between">
        <div className="flex flex-col justify-between">
          <div className="text-neutral-600 font-semibold text-base">
            {title}
          </div>
          <div className="text-primary-600 text-[12px]">
            {progress}% Complete
          </div>
        </div>
        <div className="flex flex-col items-center justify-between">
          <div className="text-primary-600 font-bold text-2xl">{points}</div>
          <div className="text-neutral-600 text-xs">PTS</div>
        </div>
      </div>
      <div className="border-b-[1.2px]  border-neutral-200 my-5"></div>
      <div className="flex justify-center">
        <CircleProgress size={140} percentage={progress} />
      </div>

      {title !== "Overall Progress" && (
        <Button
          onClick={() =>
            navigate(
              title === "Module Progress"
                ? `/educator/user/${id}/details/module`
                : `/educator/user/${id}/details/course`
            )
          }
          className="w-full h-[46px] bg-primary-600 text-white font-semibold rounded-lg mt-6"
        >
          View Details
        </Button>
      )}
    </>
  );
};

export default UserAnalytics;
